const GetPackages = async (props) => { 
    const _res = await props._api({
        ...props,
        method: "post",
        endpoint: "/api/service/internal/Reception",
        param: "",
        data: {
          PackCode: props.packagefilter,
        },
      });

    return _res;
}

export default GetPackages;